import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Component, Input, OnInit} from '@angular/core';

import {DomSanitizer} from '@angular/platform-browser';

import {APIHelper} from 'src/shared/services/api-helper/api-helper.service';

import {StorageService} from 'src/shared/services/storage/storage.service';

@Component({
  selector: 'app-display-file-icon',
  templateUrl: './display-file-icon.component.html',
  styleUrls: ['./display-file-icon.component.scss']
})
export class DisplayFileIconComponent implements OnInit {
  @Input() mimeType: string;
  @Input() nodeId: string;
  @Input() relative = false;
  @Input() size = 24;
  @Input() margin = '0';
  public srcImage: any;
  urlCreator = window.URL;
  public imageUrl;
  public _url: string;

  constructor(
    private api: APIHelper,
    private http: HttpClient,
    private storage: StorageService,
    private sanitizer: DomSanitizer
  ) {
    this.http = http;
    this.sanitizer = sanitizer;
  }

  ngOnInit() {
    if (!this.mimeType) {
      this.setThumbnail();
    } else {
      const arr = this.mimeType.split('/');
      const main = arr[0];
      if (main === 'folder') {
        this.srcImage = '/assets/img/folder.svg';
      } else if (main === 'person') {
        this.srcImage = '/assets/img/person.png';
      } else if (main === 'article') {
        this.srcImage = '/assets/img/person.png';
      } else if (main === 'text') {
        this.srcImage = '/assets/img/ft_ic_document.svg';
      } else if (main === 'image') {
        this.setThumbnail();

        // this.srcImage = this.formatUrl(this.nodeId);
        //  this.formatUrl(this.nodeId);
      } else if (main === 'video') {
        this.srcImage = '/assets/img/ft_ic_video.svg';
      } else if (main === 'audio') {
        this.srcImage = '/assets/img/ft_ic_audio.svg';
      } else if (main === 'application') {
        const appli = arr[1];

        if (appli === 'vnd.ms-excel') {
          //    this.srcImage = this.formatUrl(this.nodeId);
        } else if (appli === 'vnd.ms-powerpoint') {
          this.setThumbnail();
        } else if (appli === 'msword') {
          this.setThumbnail();
        } else if (appli === 'pdf') {
          this.setThumbnail();
        }
      }
    }
    if (!this.srcImage) {
      this.srcImage = '/assets/img/ft_ic_miscellaneous.svg';
    }
  }
  ngOnChanges() {
    /**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES 'someInput'**************/
   this.ngOnInit();
    }   

  public formatUrl(id: string) {
    const bearer = this.storage.getAsync({key: 'bearer'});
    const header = new HttpHeaders();

    const myHeader = new HttpHeaders().set('Authorization', 'Basic ' + bearer);

    const args = '?c=queue&amp;ph=true';

    this._url = `${window.location.origin}/alfresco/s/api/node/workspace/SpacesStore/${id}/content/thumbnails/doclib${args}`;

    return this.http.get(this._url, {
      headers: myHeader,
      responseType: 'blob'
    });
  }

  public setThumbnail() {
    this.formatUrl(this.nodeId).subscribe(res => {
      this.imageUrl = this.urlCreator.createObjectURL(res);
      this.sanitizer.bypassSecurityTrustUrl(this.imageUrl);
      this.srcImage = this.sanitizer.bypassSecurityTrustUrl(this.imageUrl);
    }, error1 => {
      this.srcImage = '/assets/img/ft_ic_miscellaneous.svg';
    });
  }
}
